import { useSyncExternalStore } from "react";
import {
    getConsoleCategories,
    setConsoleCategoryEnabled,
    subscribeConsoleCategories,
} from "./consoleSettings";

export const useConsoleCategories = () => {
    const enabledCategories = useSyncExternalStore(
        subscribeConsoleCategories,
        getConsoleCategories,
    );

    return { enabledCategories, setCategoryEnabled: setConsoleCategoryEnabled };
};
